import { render, staticRenderFns } from "./Projets.vue?vue&type=template&id=71f66e2e&scoped=true&lang=true"
import script from "./Projets.vue?vue&type=script&lang=js"
export * from "./Projets.vue?vue&type=script&lang=js"
import style0 from "./Projets.vue?vue&type=style&index=0&id=71f66e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f66e2e",
  null
  
)

export default component.exports